import * as Yup from 'yup';

export default Yup.object({
  title: Yup.string().required('Title is required'),
  details: Yup.string().required('Details are required'),
  activityAnalysis: Yup.string().required("Activity Analysis is required") // 45862 - TO - 20/09/2024
});
